<template>
	<v-col class="registrasi">
		<ModalTerms ref="modalTerms" :terms="dataTerms"></ModalTerms>
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :type="typeRegis"></ModalSuccess>
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" :type="typeConfirm" @action="processToClone"></ModalConfirm>

		<template v-if="!loaderData">
			<div v-show="!isSuccessReg">
				<div class="d-flex justify-space-between">
					<div class="text-h6 cl-primary">Registrasi Mitra</div>
				</div>
				<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
					<v-icon small color="grey">mdi-account-group</v-icon>
					<div class="pl-2">Jaringan</div>
					<div class="px-2">/</div>
					<div>Registrasi Mitra</div>
				</div>

				<div class="mt-5">
					<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
						<div>
							<!-- <v-form ref="formAddMembership" role="form"> -->
							<v-stepper
								v-model="stepForm"
								vertical
								id="registration-step"
								class="pa-0 pa-md-5"
								style="box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 12%), 0px 2px 2px 0px rgb(0 0 0 / 4%), 0px 1px 5px 0px rgb(0 0 0 / 2%);"
							>
								<!-- step 1 -->
								<template>
									<v-stepper-step
										:complete="stepForm > 1"
										step="1"
										:rules="[() => stepValid.step1]"
									>
										<span class="font-size-14">Data Jaringan &amp; Serial</span>
										<!-- <small class="d-block mt-2">Summarize if needed</small> -->
									</v-stepper-step>

									<v-stepper-content step="1">
										<v-form ref="formStep1" role="form">
											<v-row>
												<v-col cols="12" sm="12" md="12" class="align-stretch px-3 px-md-5">
													<div class="font-size-14 cl-primary">Data Jaringan</div>
												</v-col>

												<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-0 px-md-5 pt-md-0">
													<div class="pt-2">
														<v-text-field
															label="Kode Sponsor"
															color="primary"
															hide-details="auto"
															class="input-regis"
															prepend-inner-icon="mdi-account-tie-voice-outline"
															v-model="params.sponsor_network_code"
															tabindex="0"
															outlined
															dense
															ref="sponsor_network_code"
															:rules="rules.sponsor_code"
															@focus="$event.target.select()"
															@keyup="params.sponsor_network_code = params.sponsor_network_code.toUpperCase()"
															@blur="getMitraSponsorName(params.sponsor_network_code, 'input')"
															:error-messages="(errorValidation !== undefined && errorValidation['sponsor_network_code'] !== undefined ) ? [errorValidation['sponsor_network_code']] : []"
														>
														</v-text-field>
														<div class="pt-1 font-size-9" :class="(sponsor_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="sponsor_valid">
															{{ sponsor_name }}
														</div>
													</div>
												</v-col>
														
												<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-0 px-md-5 pt-md-0">
													<div class="pt-2">
														<v-text-field
															label="Kode Upline"
															ref="upline_network_code"
															color="primary"
															hide-details="auto"
															class="input-regis"
															prepend-inner-icon="mdi-account-network-outline"
															v-model="params.upline_network_code"
															tabindex="1"
															outlined
															dense
															:rules="rules.upline_code"
															@focus="$event.target.select()"
															@keyup="params.upline_network_code = params.upline_network_code.toUpperCase()"
															@blur="getMitraUplineName(params.upline_network_code, 'input')"
															:error-messages="(errorValidation !== undefined && errorValidation['upline_network_code'] !== undefined ) ? [errorValidation['upline_network_code']] : []"	
														>
														</v-text-field>
														<div class="pt-1 font-size-9" :class="(upline_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="upline_valid">
															{{ upline_name }}
														</div>
													</div>
												</v-col>

												<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-0 px-md-5 pt-md-0">
													<div class="pt-2">
														<v-autocomplete 
															label="Pilih Posisi Jaringan" 
															hide-details="auto" 
															no-data-text="Tidak ada data" 
															outlined
															dense
															color="primary" 
															:items="listPosition" 
															item-text="label" 
															item-value="value" 
															ref="position" 
															v-model="params.position" 
															:rules="[rules.inputreq('Posisi Jaringan', params.position)]"
															:error-messages="(errorValidation !== undefined && errorValidation['position'] !== undefined ) ? [errorValidation['position']] : []"
															tabindex="2">
															<template v-slot:selection="data">
																<v-icon dense v-if="data.item.value === 'L'" style="-webkit-transform: scaleX(-1);transform: scaleX(-1);">mdi-account-arrow-right</v-icon>
																<v-icon dense v-else>mdi-account-arrow-right-outline</v-icon>
																<span class="cl-dark ml-3">{{ data.item.label }}</span>
															</template>
														</v-autocomplete>
													</div>
												</v-col>
											</v-row>

											<v-row>
												<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-0 px-md-5 pt-md-0">
													<div class="pt-2">
														<v-text-field
															label="Serial Registrasi"
															color="primary"
															class="input-regis"
															hide-details="auto"
															ref="serial_id"
															outlined
															dense
															prepend-inner-icon="mdi-credit-card-scan-outline"
															v-model="params.serial_id"
															tabindex="3"
															@keyup="params.serial_id = params.serial_id.toUpperCase()"
															:error-messages="(errorValidation !== undefined && errorValidation['serial_id'] !== undefined ) ? [errorValidation['serial_id']] : []"
															:rules="[rules.inputreq('Nomor Serial Registrasi', params.serial_id)]"></v-text-field>	
													</div>
												</v-col>

												<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-0 px-md-5 pt-md-0">
													<div class="pt-2 pb-0 mb-1">
														<v-text-field
															ref="serialpin"
															label="PIN Serial Registrasi"
															color="primary"
															class="input-regis"
															prepend-inner-icon="mdi-credit-card-lock-outline"
															v-model="params.serial_pin"
															hide-details="auto"
															:type="typeInputSerial"
															:append-icon="iconSerial"
															@click:append="showSerial"
															outlined
															dense
															tabindex="4"
															:error-messages="(errorValidation !== undefined && errorValidation['serial_pin'] !== undefined ) ? [errorValidation['serial_pin']] : []"
															:rules="rules.serialpin"></v-text-field>
													</div>
												</v-col>
											</v-row>

											<v-card class="pa-3 mx-0 my-4 mx-md-2 pa-md-3 elevation-0 rounded-lg" outlined>
												<v-btn
													color="primary"
													tabindex="5"
													@click="step1Process()"
													class="d-none d-md-block"
													:loading="step1loading"
												>
													Lanjutkan
													<v-icon dense class="ml-1">mdi-arrow-right</v-icon>
												</v-btn>

												<v-btn
													color="primary"
													tabindex="5"
													block
													@click="step1Process()"
													class="d-block d-md-none"
													:loading="step1loading"
												>
													Lanjutkan
													<v-icon dense class="ml-1">mdi-arrow-right</v-icon>
												</v-btn>
											</v-card>
										</v-form>

									</v-stepper-content>
								</template>

								<!-- step 2 -->
								<template>
									<v-stepper-step
										:complete="stepForm > 2"
										step="2"
										:rules="[() => stepValid.step2]"
									>
										<span class="font-size-14">Data Personal</span>
									</v-stepper-step>

									<v-stepper-content step="2">
										<v-form ref="formStep2" role="form">

											<v-card outlined class="pa-5 mb-3 d-flex flex-column elevation-0 rounded-lg fill-height">
												<v-card-title class="pa-0 mb-2 mx-2"><h5>Akun Mitra</h5></v-card-title>
												<v-row>
													<!-- <v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-3 pt-md-5" v-if="false">
														<v-text-field
															label="Username"
															color="primary"
															class="input-regis"
															hide-details="auto"
															prepend-inner-icon="mdi-account"
															outlined
															dense
															ref="username"
															v-model="params.username"
															tabindex="6"
															:error-messages="(errorValidation !== undefined && errorValidation['username'] !== undefined ) ? [errorValidation['username']] : []"
															:rules="[rules.inputreq('Username', params.username)]"></v-text-field>
													</v-col> -->

													<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-3 pt-md-5">
														<v-text-field
															label="Email"
															color="primary"
															class="input-regis"
															prepend-inner-icon="mdi-email"
															hide-details="auto"
															v-model="params.email"
															tabindex="7"
															outlined
															dense
															ref="email"
															:error-messages="(errorValidation !== undefined && errorValidation['email'] !== undefined ) ? [errorValidation['email']] : []"
															:rules="rules.email"></v-text-field>
													</v-col>

													<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-3 pt-md-5">
														<v-text-field 
															label="Password"
															color="primary"
															class="input-regis"
															prepend-inner-icon="mdi-key-variant"
															v-model="params.password"
															hide-details="auto"
															:type="typeInput"
															:append-icon="icon"
															@click:append="showPassword"
															outlined
															dense
															tabindex="8"
															:error-messages="(errorValidation !== undefined && errorValidation['password'] !== undefined ) ? [errorValidation['password']] : []"
															:rules="rules.password"></v-text-field>
													</v-col>
												</v-row>
											</v-card>

											<v-card outlined class="pa-5 mb-3 d-flex flex-column elevation-0 rounded-lg fill-height">
												<v-card-title class="pa-0 mb-4 mx-2"><h5>Biodata Mitra</h5></v-card-title>
												
												<v-row>
													<v-col cols="12" sm="8" md="8">
														<v-row class="">
															<v-col cols="12" sm="4" md="4">
																<v-autocomplete 
																	label="Pilih Jenis Kelamin" 
																	hide-details="auto" 
																	no-data-text="Tidak ada data" 
																	outlined
																	dense
																	color="primary" 
																	:items="listGender" 
																	item-text="label" 
																	item-value="value" 
																	ref="gender" 
																	v-model="params.gender" 
																	:rules="[rules.inputreq('Jenis Kelamin', params.gender)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['gender'] !== undefined ) ? [errorValidation['gender']] : []"
																	tabindex="9"></v-autocomplete>
															</v-col>

															<v-col cols="12" sm="8" md="8">
																<v-text-field
																	label="Nama Lengkap"
																	color="primary"
																	class="input-regis"
																	hide-details="auto"
																	prepend-inner-icon="mdi-account"
																	outlined
																	dense
																	ref="name"
																	v-model="params.name"
																	tabindex="10"
																	@blur="params.bank_account_name = params.name, params.receiver_name = params.name"
																	:error-messages="(errorValidation !== undefined && errorValidation['name'] !== undefined ) ? [errorValidation['name']] : []"
																	:rules="[rules.inputreq('Nama Mitra', params.name)]"></v-text-field>
															</v-col>
														</v-row>

														<v-row class="">
															<v-col cols="12" sm="4" md="4">
																<v-menu 
																	v-model="birthDate"
																	:close-on-content-click="false"
																	:nudge-right="0"
																	transition="scale-transition"
																	offset-y min-width="290px">
																	<template v-slot:activator="{ on, attrs }">
																		<v-text-field
																			label="Tanggal Lahir"
																			color="primary"
																			class="input-regis"
																			prepend-inner-icon="mdi-calendar"
																			readonly
																			v-bind="attrs"
																			v-on="on"
																			outlined
																			dense
																			hide-details="auto"
																			tabindex="11"
																			:error-messages="(errorValidation !== undefined && errorValidation['birth_date'] !== undefined ) ? [errorValidation['birth_date']] : []"
																			:value="convertDate(params.birth_date)"
																			:rules="[rules.inputreq('Tanggal Lahir', params.birth_date)]"></v-text-field>
																	</template>
																	<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="birthDate = false" hide-details="auto" v-model="params.birth_date"></v-date-picker>
																</v-menu>
															</v-col>
															<v-col cols="12" sm="8" md="8">
																<v-text-field
																	label="Tempat Lahir"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-map-marker-right-outline"
																	hide-details="auto"
																	v-model="params.birth_place"
																	tabindex="12"
																	outlined
																	dense
																	:error-messages="(errorValidation !== undefined && errorValidation['birth_place'] !== undefined ) ? [errorValidation['birth_place']] : []"
																	:rules="[rules.inputreq('Tempat Lahir', params.birth_place)]"></v-text-field>
															</v-col>
														</v-row>

														<v-row class="">
															<v-col cols="12" sm="4" md="4"></v-col>
															<v-col cols="12" sm="8" md="8">
																<v-text-field
																	label="Nomor Handphone"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-cellphone"
																	v-model="params.mobilephone"
																	hide-details="auto"
																	maxlength="15"
																	:rules="rules.nohp"
																	outlined
																	dense
																	ref="mobilePhone"
																	tabindex="13"
																	:error-messages="(errorValidation !== undefined && errorValidation['mobilephone'] !== undefined ) ? [errorValidation['mobilephone']] : []"
																	@blur="params.receiver_mobilephone = params.mobilephone"
																	@keypress="onlyNumber"
																	@paste.prevent></v-text-field>
																	<!-- @paste="validatePaste($event)" -->
															</v-col>
														</v-row>

														<v-row class="">
															<v-col cols="12" sm="4" md="4">
																<v-autocomplete
																	label="Pilih Jenis Identitas" 
																	hide-details="auto" 
																	no-data-text="Tidak ada data" 
																	outlined
																	dense
																	color="primary" 
																	:items="['KTP', 'SIM', 'PASPOR']"
																	ref="identity_type" 
																	v-model="params.identity_type" 
																	:rules="[rules.inputreq('Jenis Identitas', params.identity_type)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['identity_type'] !== undefined ) ? [errorValidation['identity_type']] : []"
																	tabindex="14"></v-autocomplete>
															</v-col>
															
															<v-col cols="12" sm="8" md="8">
																<v-text-field
																	label="Nomor Identitas"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-card-account-details"
																	hide-details="auto"
																	v-model="params.identity_no"
																	ref="identityNo"
																	outlined
																	dense
																	tabindex="15"
																	counter="20"
																	:rules="rules.noktp"
																	:error-messages="(errorValidation !== undefined && errorValidation['identity_no'] !== undefined ) ? [errorValidation['identity_no']] : []"
																	@paste="validatePaste($event, 'ktp')"></v-text-field>
															</v-col>
														</v-row>
													</v-col>

													<v-col cols="12" sm="4" md="4">
														<v-card outlined class="pa-5 d-flex flex-column elevation-0 rounded-lg fill-height">
															<v-row class="d-flex align-center">
																<v-col cols="15" class="d-none">
																	<v-file-input
																		id="uploadIdentity"
																		hide-input
																		accept="image/png, image/jpeg, image/jpg"
																		prepend-icon="mdi-camera"
																		label="Pilih gambar"
																		v-model="identity_image_upload"
																		:rules="rules.fileidentity"
																		@change="previewImageIdentity($event)"></v-file-input>
																</v-col>
																<v-col cols="12" class="d-flex align-center justify-space-between flex-column pt-0">
																	<div style="display: block; position: relative; min-width: 160px; width: auto; max-width: 100%; margin: 0 auto;">
																		<v-img max-width="100%" width="auto" height="180px" class="rounded-lg d-block mx-auto" :src="(identity_image_url) ? identity_image_url : '/assets/image/no-image.png'" style="border: 1px solid #ddd;"></v-img>
																		<v-btn
																			elevation="3"
																			fab
																			icon
																			outlined
																			raised
																			rounded
																			small
																			class="btn-zoom"
																			@click="dialogZoomOpen(identity_image_url)"
																			v-if="identity_image_upload"
																		><v-icon color="#fff">mdi-magnify-plus-outline</v-icon></v-btn>
																		<v-btn
																			elevation="3"
																			color="error"
																			fab
																			icon
																			outlined
																			raised
																			rounded
																			x-small
																			style="position: absolute; top: -10px; right: -10px;background: #fff;"
																			@click="clearIdentityImg"
																			v-if="identity_image_upload"
																		><v-icon>mdi-close</v-icon></v-btn>
																	</div>

																	<v-btn
																		depressed
																		block
																		outlined
																		height="40px"
																		:color="(!identity_image_upload) ? 'red' : '#408285'"
																		class="text-capitalize mt-4"
																		tabindex="16"
																		:loading="btn_loading"
																		:disabled="(identity_image_upload) ? true : false"
																		@click="openIdentityUpload">
																		<v-icon>mdi-file-upload-outline</v-icon>
																		<span class="pr-2 ms-2">Upload {{ params.identity_type }}</span>
																	</v-btn>

																	<small class="red--text" v-if="(errorValidation !== undefined && errorValidation['identity_image'] !== undefined) || !identity_image_upload">
																		{{ (errorValidation !== undefined && errorValidation['identity_image'] !== undefined) ? errorValidation['identity_image'] : (!identity_image_upload) ? 'Foto kartu identitas tidak boleh kosong.' : '' }}
																	</small>
																</v-col>
															</v-row>
														</v-card>
													</v-col>
												</v-row>
											</v-card>

											<v-card outlined class="pa-5 mb-3 d-flex flex-column elevation-0 rounded-lg fill-height">
												<v-card-title class="pa-0 mb-2 mx-2"><h5>Alamat Mitra</h5></v-card-title>
												<v-row>
													<v-col cols="12" sm="8" md="8">
														<v-textarea
															name="alamat"
															label="Alamat"
															v-model="params.address"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-radius-outline"
															counter="255"
															maxlenght="255"
															rows="5"
															outlined
															dense
															tabindex="17"
															:rules="[rules.inputreq('Alamat', params.address)]"
															:error-messages="(errorValidation !== undefined && errorValidation['address'] !== undefined ) ? [errorValidation['address']] : []"
														></v-textarea>
													</v-col>

													<v-col cols="12" sm="4" md="4">
														<v-autocomplete
															label="Provinsi"
															no-data-text="Tidak ada data"
															color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="province"
															item-text="province_name"
															item-value="province_id"
															v-model="params.province_id"
															tabindex="18"
															outlined
															dense
															class="mb-3"
															:rules="[rules.inputreq('Provinsi', params.province_id)]"
															:error-messages="(errorValidation !== undefined && errorValidation['province_id'] !== undefined ) ? [errorValidation['province_id']] : []"
															@change="changeProvince"></v-autocomplete>

															<v-autocomplete
																label="Kota"
																no-data-text="Pilih Provinsi Dahulu"
																color="primary"
																hide-details="auto"
																prepend-inner-icon="mdi-map-marker-right-outline"
																:items="city"
																item-text="city_name"
																item-value="city_id"
																v-model="params.city_id"
																outlined
																dense
																tabindex="19"
																class="mb-3"
																:rules="[rules.inputreq('Kota/Kabupaten', params.city_id)]"
																:error-messages="(errorValidation !== undefined && errorValidation['city_id'] !== undefined ) ? [errorValidation['city_id']] : []"
																@change="changeCity">
																	<template v-slot:item="data">
																		<span class="cl-dark">{{ data.item.city_type + ' ' + data.item.city_name }}</span>
																	</template>
																	<template v-slot:selection="data">
																		<span class="cl-dark">{{ data.item.city_type + ' ' + data.item.city_name }}</span>
																	</template>
																</v-autocomplete>

															<v-autocomplete
																label="Kecamatan"
																no-data-text="Tidak ada data"
																color="primary"
																hide-details="auto"
																prepend-inner-icon="mdi-map-marker-right-outline"
																:items="subdistrict"
																item-text="subdistrict_name"
																item-value="subdistrict_id"
																v-model="params.subdistrict_id"
																tabindex="20"
																outlined
																:rules="[rules.inputreq('Kecamatan', params.subdistrict_id)]"
																:error-messages="(errorValidation !== undefined && errorValidation['subdistrict_id'] !== undefined ) ? [errorValidation['subdistrict_id']] : []"
																dense></v-autocomplete>
													</v-col>
												</v-row>
											</v-card>

											<v-card outlined class="pa-5 mb-3 d-flex flex-column elevation-0 rounded-lg fill-height">
												<v-card-title class="pa-0 mb-2 mx-2"><h5>Alamat Pengiriman</h5></v-card-title>
												<v-row>
													<v-col cols="12" sm="4" md="4">
														<v-text-field
															label="Nama Penerima"
															color="primary"
															class="input-regis"
															hide-details="auto"
															prepend-inner-icon="mdi-account"
															outlined
															dense
															ref="receiver_name"
															v-model="params.receiver_name"
															tabindex="21"
															:error-messages="(errorValidation !== undefined && errorValidation['receiver_name'] !== undefined ) ? [errorValidation['receiver_name']] : []"
															:rules="[rules.inputreq('Nama Penerima', params.receiver_name)]"></v-text-field>
													</v-col>

													<v-col cols="12" sm="4" md="4">
															<v-text-field
																label="Nomor Handphone Penerima"
																color="primary"
																class="input-regis"
																prepend-inner-icon="mdi-cellphone"
																v-model="params.receiver_mobilephone"
																hide-details="auto"
																maxlength="15"
																:rules="rules.nohp"
																outlined
																dense
																ref="receiver_mobilephone"
																tabindex="22"
																:error-messages="(errorValidation !== undefined && errorValidation['receiver_mobilephone'] !== undefined ) ? [errorValidation['receiver_mobilephone']] : []"
																@keypress="onlyNumber"
																@paste.prevent></v-text-field>
														</v-col>
												</v-row>
												
												<v-row>
													<v-col cols="12" sm="8" md="8">
														<v-checkbox
															v-model="isEqualAddress"
															class="ma-0"
															style="margin-bottom: -5px!important;"
															tabindex="23"
															@change="setReceiverAddress()"
														>
															<template slot="label">
																<span class="d-flex align-center">
																	Gunakan alamat utama sebagai alamat tujuan pengiriman.
																</span>
															</template>
														</v-checkbox>

														<v-textarea
															name="receiver_address"
															label="Alamat"
															v-model="params.receiver_address"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-radius-outline"
															counter="255"
															maxlenght="255"
															rows="3"
															outlined
															dense
															tabindex="24"
															:disabled="isEqualAddress"
															:rules="[rules.inputreq('Alamat Pengiriman', params.receiver_address)]"
															:error-messages="(errorValidation !== undefined && errorValidation['receiver_address'] !== undefined ) ? [errorValidation['receiver_address']] : []"
														></v-textarea>
													</v-col>

													<v-col cols="12" sm="4" md="4">
														<v-autocomplete
															label="Provinsi"
															no-data-text="Tidak ada data"
															color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="province"
															item-text="province_name"
															item-value="province_id"
															v-model="params.receiver_province_id"
															tabindex="25"
															outlined
															dense
															class="mb-3"
															:disabled="isEqualAddress"
															:rules="[rules.inputreq('Provinsi Pengiriman', params.receiver_province_id)]"
															:error-messages="(errorValidation !== undefined && errorValidation['receiver_province_id'] !== undefined ) ? [errorValidation['receiver_province_id']] : []"
															@change="changeProvinceReceiver"></v-autocomplete>

															<v-autocomplete
																label="Kota"
																no-data-text="Pilih Provinsi Dahulu"
																color="primary"
																hide-details="auto"
																prepend-inner-icon="mdi-map-marker-right-outline"
																:items="city"
																item-text="city_name"
																item-value="city_id"
																v-model="params.receiver_city_id"
																outlined
																dense
																tabindex="26"
																class="mb-3"
																:disabled="isEqualAddress"
																:rules="[rules.inputreq('Kota/Kabupaten Pengiriman', params.receiver_city_id)]"
																:error-messages="(errorValidation !== undefined && errorValidation['receiver_city_id'] !== undefined ) ? [errorValidation['receiver_city_id']] : []"
																@change="changeCityReceiver">
																	<template v-slot:item="data">
																		<span class="cl-dark">{{ data.item.city_type + ' ' + data.item.city_name }}</span>
																	</template>
																	<template v-slot:selection="data">
																		<span class="cl-dark">{{ data.item.city_type + ' ' + data.item.city_name }}</span>
																	</template>
																</v-autocomplete>

															<v-autocomplete
																label="Kecamatan"
																no-data-text="Tidak ada data"
																color="primary"
																hide-details="auto"
																prepend-inner-icon="mdi-map-marker-right-outline"
																:items="subdistrict"
																item-text="subdistrict_name"
																item-value="subdistrict_id"
																v-model="params.receiver_subdistrict_id"
																tabindex="27"
																outlined
																:disabled="isEqualAddress"
																:rules="[rules.inputreq('Kecamatan Pengiriman', params.receiver_subdistrict_id)]"
																:error-messages="(errorValidation !== undefined && errorValidation['receiver_subdistrict_id'] !== undefined ) ? [errorValidation['receiver_subdistrict_id']] : []"
																dense></v-autocomplete>
													</v-col>
												</v-row>
											</v-card>

											<v-card outlined class="pa-5 mb-3 d-flex flex-column elevation-0 rounded-lg fill-height">
												<v-card-title class="pa-0 mb-2 mx-2"><h5>Info Waris Mitra</h5></v-card-title>
												<v-row>
													<v-col cols="12" sm="4" md="4">
														<v-text-field
															label="Nama Ibu Kandung"
															color="primary"
															class="input-regis"
															hide-details="auto"
															prepend-inner-icon="mdi-account"
															v-model="params.mother_name"
															outlined
															dense
															:rules="[rules.inputreq('Nama Ibu Kandung', params.mother_name)]"
															:error-messages="(errorValidation !== undefined && errorValidation['mother_name'] !== undefined ) ? [errorValidation['mother_name']] : []"
															tabindex="28"></v-text-field>
													</v-col>
												</v-row>

												<v-row>
													<v-col cols="12" sm="4" md="4">
														<v-text-field
															label="Nama Ahli Waris"
															color="primary"
															class="input-regis"
															hide-details="auto"
															prepend-inner-icon="mdi-account"
															v-model="params.devisor_name"
															outlined
															dense
															:rules="[rules.inputreq('Nama Ahli Waris', params.devisor_name)]"
															:error-messages="(errorValidation !== undefined && errorValidation['devisor_name'] !== undefined ) ? [errorValidation['devisor_name']] : []"
															tabindex="29"></v-text-field>
													</v-col>

													<v-col cols="12" sm="4" md="4">
														<v-text-field
															label="Hubungan Ahli Waris"
															color="primary"
															class="input-regis"
															hide-details="auto"
															prepend-inner-icon="mdi-account"
															v-model="params.devisor_relation"
															outlined
															dense
															:rules="[rules.inputreq('Hubungan Ahli Waris', params.devisor_relation)]"
															:error-messages="(errorValidation !== undefined && errorValidation['devisor_relation'] !== undefined ) ? [errorValidation['devisor_relation']] : []"
															tabindex="30"></v-text-field>
													</v-col>

													<v-col cols="12" sm="4" md="4">
														<v-text-field
															label="No. HP Ahli Waris"
															color="primary"
															class="input-regis"
															hide-details="auto"
															prepend-inner-icon="mdi-cellphone"
															v-model="params.devisor_mobilephone"
															outlined
															dense
															:rules="rules.nohp"
															:error-messages="(errorValidation !== undefined && errorValidation['devisor_mobilephone'] !== undefined ) ? [errorValidation['devisor_mobilephone']] : []"
															tabindex="31"
															@keypress="onlyNumber"
															@paste.prevent></v-text-field>
													</v-col>
												</v-row>
											</v-card>
											
											<v-card class="d-none d-md-block pa-3 mx-0 my-4 elevation-0 rounded-lg" outlined>
												<v-row>
													<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3 px-md-5">
														<v-btn text class="mr-2" @click="backStep(1)">
															<v-icon dense class="mr-1">mdi-square-edit-outline</v-icon>
															Sebelumnya
														</v-btn>
														<v-btn
															color="primary"
															tabindex="32"
															@click="step2Process()"
														>
															Lanjutkan
															<v-icon dense class="ml-1">mdi-arrow-right</v-icon>
														</v-btn>
													</v-col>
												</v-row>
											</v-card>

											<v-card class="d-block d-md-none pa-3 mx-0 my-4 elevation-0 rounded-lg" outlined>
												<v-row>
													<v-col cols="12" sm="12" md="12" class="align-stretch pt-3">
														<v-btn block text class="mb-2" @click="backStep(1)">
															<v-icon dense class="mr-1">mdi-square-edit-outline</v-icon>
															Sebelumnya
														</v-btn>
														<v-btn
															color="primary"
															block
															tabindex="33"
															@click="step2Process()"
														>
															Lanjutkan
															<v-icon dense class="ml-1">mdi-arrow-right</v-icon>
														</v-btn>
													</v-col>
												</v-row>
											</v-card>
										</v-form>
									</v-stepper-content>
								</template>
								
								<!-- step 3 -->
								<template>
									<v-stepper-step
										:complete="stepForm > 3"
										step="3"
									>
										<span class="font-size-14">Data Bank</span>
									</v-stepper-step>

									<v-stepper-content step="3">
										<v-form ref="formStep3" role="form">
											<v-card outlined class="pa-5 mb-3 d-flex flex-column elevation-0 rounded-lg fill-height">
												<v-card-title class="pa-0 mb-4 mx-2"><h5>Data Rekening Mitra</h5></v-card-title>
												
												<v-row>
													<v-col cols="12" sm="4" md="4">
														<v-text-field
															label="Nama Pemillik Rekening"
															color="primary"
															hide-details="auto"
															ref="bank_account_name"
															prepend-inner-icon="mdi-account"
															v-model="params.bank_account_name"
															outlined
															dense
															:disabled="true"
															:rules="[rules.inputreq('Nama Pemilik Rekening', params.bank_account_name)]"
															:error-messages="(errorValidation !== undefined && errorValidation['bank_account_name'] !== undefined ) ? [errorValidation['bank_account_name']] : []"
															tabindex="34"></v-text-field>
													</v-col>

													<v-col cols="12" sm="4" md="4">
														<v-text-field
															ref="accountNo"
															label="Nomor Rekening"
															color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-account-box-outline"
															v-model="params.bank_account_no"
															tabindex="35"
															outlined
															dense
															:rules="[rules.inputreq('Nomor Rekening', params.bank_account_no)]"
															:error-messages="(errorValidation !== undefined && errorValidation['bank_account_no'] !== undefined ) ? [errorValidation['bank_account_no']] : []"
															@keypress="onlyNumber"
															@paste.prevent></v-text-field>
													</v-col>

													<v-col cols="12" sm="4" md="4">
														<v-autocomplete
															label="Nama Bank"
															hide-details="auto"
															no-data-text="Tidak ada data"
															color="primary"
															prepend-inner-icon="mdi-bank-outline"
															:items="bank"
															item-text="bank_name"
															item-value="bank_id"
															v-model="params.bank_id"
															tabindex="36"
															return-object
															outlined
															dense
															:rules="[rules.inputreq('Nama Bank', params.bank_id)]"
															:error-messages="(errorValidation !== undefined && errorValidation['bank_id'] !== undefined ) ? [errorValidation['bank_id']] : []"
															@change="selectBank()"></v-autocomplete>
													</v-col>
												</v-row>
												
												<v-row>
													<v-col cols="12" sm="4" md="4">
														<v-autocomplete
															label="Provinsi Bank"
															no-data-text="Tidak ada data"
															color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="province"
															item-text="province_name"
															item-value="province_id"
															v-model="params.bank_province_id"
															tabindex="37"
															:rules="[rules.inputreq('Provinsi Lokasi Bank', params.bank_province_id)]"
															outlined
															dense
															@change="changeBankProvince"></v-autocomplete>
													</v-col>

													<v-col cols="12" sm="4" md="4">
														<v-autocomplete 
															label="Kota Bank"
															hide-details="auto"
															no-data-text="Pilih Kota Bank"
															color="primary"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="listBankCities"
															item-text="city_name"
															item-value="city_name"
															v-model="params.bank_city"
															outlined
															dense
															:rules="[rules.inputreq('Kota Lokasi Bank', params.bank_city)]"
															:error-messages="(errorValidation !== undefined && errorValidation['city_name'] !== undefined ) ? [errorValidation['city_name']] : []"
															tabindex="38">
																<template v-slot:item="data">
																	<span class="cl-dark">{{ data.item.city_type + ' ' + data.item.city_name }}</span>
																</template>
																<template v-slot:selection="data">
																	<span class="cl-dark">{{ data.item.city_type + ' ' + data.item.city_name }}</span>
																</template>
															</v-autocomplete>
													</v-col>

													<v-col cols="12" sm="4" md="4">
														<v-text-field
															label="Nama Cabang"
															color="primary"
															hide-details="auto"
															v-model="params.bank_branch"
															prepend-inner-icon="mdi-office-building-marker-outline"
															outlined
															dense
															:rules="[rules.inputreq('Nama Cabang Bank', params.bank_branch)]"
															:error-messages="(errorValidation !== undefined && errorValidation['bank_branch'] !== undefined ) ? [errorValidation['bank_branch']] : []"
															tabindex="39"></v-text-field>
													</v-col>
												</v-row>
											</v-card>

											<v-card class="pa-3 pa-md-4 my-4 elevation-0 rounded-lg" outlined>
												<v-row>
													<v-col cols="12" sm="12" md="12">
														<v-checkbox
															v-model="isAgreed"
															class="ma-0"
															style="margin-bottom: -15px!important;"
															tabindex="40"
															:rules="rules.input"
														>
															<template slot="label">
																<span class="d-none d-md-flex align-center">
																	Saya telah membaca dan menyetujui 
																	<v-btn x-small text color="primary" @click="showTerms()" class="font-weight-bold py-0 mt-1 px-1 ml-1">
																		syarat &amp; ketentuan yang berlaku.
																	</v-btn>
																</span>

																<span class="d-flex d-md-none flex-column">
																	<span class="d-flex flex-wrap">Saya telah membaca dan menyetujui</span>
																	<v-btn x-small text color="primary" @click="showTerms()" class="d-flex flex-wrap justify-start text-left font-weight-bold py-0 px-0 mt-1">
																		syarat &amp; ketentuan<br>yang berlaku.
																	</v-btn>
																</span>
															</template>
														</v-checkbox>
													</v-col>
												</v-row>
											</v-card>
										</v-form>
										
										<v-card class="d-none d-md-block pa-3 my-4 pa-md-3 elevation-0 rounded-lg" outlined>
											<v-row>
												<v-col cols="12" sm="12" md="12">
													<v-btn text class="ml-2" @click="backStep(2)">
														<v-icon dense class="mr-1">mdi-square-edit-outline</v-icon> Sebelumnya
													</v-btn>
												</v-col>
											</v-row>
										</v-card>

										<v-card class="d-block d-md-none pa-3 my-4 pa-md-3 elevation-0 rounded-lg" outlined>
											<v-row>
												<v-col cols="12" sm="12" md="12">
													<v-btn block text class="" @click="backStep(2)">
														<v-icon dense class="mr-1">mdi-square-edit-outline</v-icon> Sebelumnya
													</v-btn>
												</v-col>
											</v-row>
										</v-card>
									</v-stepper-content>
								</template>
							</v-stepper>

							<v-row justify="center" class="pt-5 ml-0">
								<v-col cols="6" sm="3" md="2" class="pl-0">
									<v-btn large depressed block color="grey" class="white--text rounded-lg" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="goBack">
										<v-icon>mdi-arrow-left</v-icon>
										<span class="pl-2">Batal</span>
									</v-btn>
								</v-col>
								<v-col cols="6" sm="3" md="2" class="pl-0">
									<v-btn large depressed block class="bg-primary white--text rounded-lg" :loading="btnLoadingProses" :disabled="(isAgreed && stepForm === 3) ? false : true" tabindex="41" @click="processInput">
										<v-icon>mdi-content-save-outline</v-icon>
										<span class="pl-2">Simpan</span>
									</v-btn>
								</v-col>
							</v-row>
						</div>
					</v-scroll-x-reverse-transition>

					<v-dialog
						v-model="dialogZoom"
						max-width="600"
					>
						<v-img width="600px" :src="(imgzoom) ? imgzoom : '/assets/image/no-image.png'" class="d-block mx-auto pa-5" style="border: 1px solid #ddd;background: #fff;"></v-img>
					</v-dialog>
				</div>
			</div>

			<template v-if="isSuccessReg">
				<ReportRegistrasi :data="tempRegister" :voUrlHost="voUrlOrigin" :voUrlOrigin="voUrlOrigin"></ReportRegistrasi>
			</template>
		</template>

		<template v-else>
			<LoadData :loading="loaderData"></LoadData>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalTerms from './components/ModalTerms'
import ModalSuccess from './components/ModalSuccess'
import ModalConfirm from './components/ModalConfirm'
import ReportRegistrasi from '@/components/layout/vo/ReportRegistrasi'

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export default {
	components: {
		ModalTerms, ModalSuccess, ModalConfirm, ReportRegistrasi
	},
	data() {
		return {
			loaderData: false,
			loading: false,
			isSuccessReg: false,
			btn_loading: false,
			step1loading: false,
			stepForm: 1,
			stepValid: {
				step1: true,
				step2: true,
				step3: true
			},
			typeInput: 'password',
			typeConfirm: 'confirm',
			typeInputSerial: 'password',
			icon: 'mdi-eye',
			iconSerial: 'mdi-eye',
			page: 1,
			limit: '100',
			btnLoadingProses: false,
			suksesInput: false,
			isUplineExist: false,
			isAgreed: false,
			stores_image: null,
			dataTerms: null,
			dialogZoom: false,
			imgzoom: '',
			msgConfirm: '',
			sponsor_name: '',
			sponsor_valid: true,
			upline_name: '',
			upline_valid: true,
			birthDate: '',
			identity_image_upload: null,
			identity_image_url: '',
			tempRegister: null,
			isEqualAddress: false,
			voUrlOrigin: '',
			voUrlHost: '',
			params: {
				sponsor_network_code: '',
				upline_network_code: '',
				position: 'L',
				serial_id: '',
				serial_pin: '',
				username: '',
				password: '',
				name: '',
				email: '',
				identity_type: '',
				identity_no: '',
				identity_image: null,
				mobilephone: '',
				gender: 'Laki-laki',
				birth_place: '',
				birth_date: null,
				address: '',
				subdistrict_id: '',
				city_id: '',
				province_id: '',
				country_id: '102',
				receiver_name: '',
				receiver_mobilephone: '',
				receiver_address: '',
				receiver_subdistrict_id: '',
				receiver_city_id: '',
				receiver_province_id: '',
				bank_id: '',
				bank_name: '',
				bank_account_name: '',
				bank_account_no: '',
				bank_branch: '',
				bank_province_id: '',
				bank_city: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				devisor_mobilephone: ''
			},
			listPosition: [
				{
					label: 'Kanan',
					value: 'R'
				},
				{
					label: 'Kiri',
					value: 'L'
				}
			],
			listGender: [
				{
					label: 'Laki-laki',
					value: 'Laki-laki'
				},
				{
					label: 'Perempuan',
					value: 'Perempuan'
				}
			],
			rules: {
				fileidentity: [
					v => !!v || 'File scan/foto identitas tidak boleh kosong',
					v => (v && v.size > 0) || 'File scan/foto identitas tidak boleh kosong',
				],
				inputreq(label, v) { 
					return !!v || label + ' tidak boleh kosong'
				},
				agreedCheck(label, v) { 
					return !!v || 'Anda harus memberikan persetujuan tentang ' + label
				},
				input: [
					v => !!v || 'Tidak boleh kosong'
				],
				sponsor_code: [
					v => !!v || 'Kode Sponsor tidak boleh kosong',
					v => ( v && this.sponsor_valid ) || "Data mitra tidak ditemukan",
				],
				upline_code: [
					v => !!v || 'Kode Upline tidak boleh kosong',
					v => ( v && this.upline_valid ) || "Data mitra tidak ditemukan",
				],
				position: [
					v => !!v || 'Posisi Jaringan wajib dipilih',
				],
				serialpin: [
					v => !!v || 'PIN Serial tidak boleh kosong'
				],
				password: [
					v => !!v || 'Tidak boleh kosong',
					v => ( v && v.length >= 6 ) || "Password tidak boleh kurang dari 6 karakter",
				],
				email: [
					v => !!v || 'Email tidak boleh kosong',
					v => !!validateEmail(v) || 'Format Email tidak sesuai',
				],
				noktp: [
					v => !!v || 'Nomor KTP tidak boleh kosong',
					// v => ( v && v.length >= 16 ) || "Nomor KTP tidak boleh kurang dari 16 angka",
					// v => ( v && v.length <= 16 ) || "Nomor KTP tidak boleh lebih dari 16 angka",
				],
				nohp: [
					v => !!v || 'Nomor Handphone tidak boleh kosong',
					v => ( v && v.length <= 16 ) || "Nomor Handphone tidak boleh lebih dari 16 angka",
					v => ( v && v.length > 10 ) || "Nomor Handphone tidak boleh kurang dari 10 angka",
				],
			},
			msgSuccess: '',
			msgFailed: '',
			typeRegis: ''
		}
	},
	watch: {
    // eslint-disable-next-line no-unused-vars
    async $route(to, from) {
			if (to.query.upline !== undefined && to.query.position !== undefined) {
				this.params.upline_network_code = await to.query.upline
				this.params.position = await to.query.position
				this.isUplineExist = await true
				if (to.query.upline) {
					this.getMitraUplineName(to.query.upline)
				} else {
					this.upline_name = await ''
					this.upline_valid = await false
				}
			} else {
				this.params.upline_network_code = await ''
				this.params.position = await ''
				this.isUplineExist = await false
				this.upline_name = ''
				this.upline_valid = false
			}
			await this.$store.dispatch('setPageTitle', 'Registrasi Mitra')
			await this.getData()

			setTimeout(() => {
				this.$refs.serial_id.focus()
			}, 200);
    },

		// eslint-disable-next-line no-unused-vars
		errorValidation(newData, oldData) {
			if (newData !== undefined) {
				const step1key = ['sponsor_network_code', 'upline_network_code', 'position', 'serial_id', 'serial_pin']
				const step2key = ['password', 'name', 'email', 'identity_type', 'identity_no', 'identity_image', 'mobilephone', 'gender', 'birth_place', 'birth_date', 'address', 'subdistrict_id', 'city_id', 'province_id', 'mother_name', 'devisor_name', 'devisor_relation']
				const step3key = ['bank_id', 'bank_account_name', 'gender', 'email', 'password', 'mobilephone']
	
				const step1 = step1key.some(r=> Object.keys(newData).indexOf(r) >= 0)
				const step2 = step2key.some(r=> Object.keys(newData).indexOf(r) >= 0)
				const step3 = step3key.some(r=> Object.keys(newData).indexOf(r) >= 0)
	
				if (step1) {
					this.stepForm = 1
					this.stepValid.step1 = false
				} else if (step2) {
					this.stepForm = 2
					this.stepValid.step2 = false
				} else if (step3) {
					this.stepForm = 3
					this.stepValid.step3 = false
				}
			}
			
			return true
		},

		sponsor_valid() {
			this.stepValid.step1 = this.$refs.formStep1.validate()
		},
		upline_valid() {
			this.stepValid.step1 = this.$refs.formStep1.validate()
		},
  },
	computed: {
		...mapState('auth', ['userData']),
		...mapState('registration', ['mitraData', 'isCloneMitra', 'responSuksesRegis', 'responseError', 'errorValidation']),
		...mapState('profile', ['myProfile', 'myBank']),
		...mapState('option', ['province', 'city', 'subdistrict', 'bank', 'listBankCities']),
	},
	methods: {
		...mapActions('registration', ['getMitraByNetworkCode', 'checkRegistration', 'addRegistration', 'resetValidation']),
		...mapActions('option', ['getProvince', 'getCity', 'getSubdistrict', 'getBank', 'getBankCity']),

		async validatePaste(val, type){
			let pasted = await val.clipboardData.getData('text')
			setTimeout(() => {
				if (!parseInt(pasted)) {
					if (type === 'ktp') {
						val.preventDefault()
					} else {
						val.preventDefault()
					}
				}
			})
		},

		checkLocation() {
			const base_url = window.location.origin
			if (base_url === 'http://office.dsn-world.com' || base_url === 'https://office.dsn-world.com') {
				this.voUrlOrigin = 'https://office.dsn-world.com'
				this.voUrlhost = 'office.dsn-world.com'
			} else {
				this.voUrlOrigin = 'https://dsn-vo.esoftdream.co.id'
				this.voUrlHost = 'dsn-vo.esoftdream.co.id'
			}
		},

		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},

		showSerial() {
			this.typeInputSerial = this.typeInputSerial == 'text' ? 'password' : 'text'
			this.iconSerial = this.iconSerial == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},

		goBack() {
			this.$router.push({name: 'genealogy'})
		},

		reset() {
			this.birthDate = null
			this.identity_image_upload = null
			this.identity_image_url = ''
			this.dataTerms = null
			this.isAgreed = false
			this.sponsor_name = ''
			this.sponsor_valid = true
			this.upline_name = ''
			this.upline_valid = true
			this.isEqualAddress = false

			this.params = {
				sponsor_network_code: '',
				upline_network_code: '',
				position: '',
				serial_id: '',
				serial_pin: '',
				username: '',
				password: '',
				name: '',
				email: '',
				identity_type: '',
				identity_no: '',
				identity_image: null,
				mobilephone: '',
				gender: 'Laki-laki',
				birth_place: '',
				birth_date: null,
				address: '',
				subdistrict_id: '',
				city_id: '',
				province_id: '',
				country_id: '102',
				receiver_name: '',
				receiver_mobilephone: '',
				receiver_address: '',
				receiver_subdistrict_id: '',
				receiver_city_id: '',
				receiver_province_id: '',
				bank_id: '',
				bank_name: '',
				bank_account_name: '',
				bank_account_no: '',
				bank_branch: '',
				bank_province_id: '',
				bank_city: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				devisor_mobilephone: ''
			}

			this.stepForm = 1
		},

		getTermContent() {
			this.dataTerms = {
				title: 'Syarat & ketentuan mitra yang berlaku',
				content: 'Belum ada konten yang tersedia.'
			}
		},

		showTerms() {
			this.$refs.modalTerms.modalShow()
			// let routeData = 'https://demomlm.esoftdream.co.id/'
			// window.open(routeData, '_blank');
		},

		openIdentityUpload() {
			document.getElementById('uploadIdentity').click()
		},

		clearIdentityImg() {
			this.identity_image_upload = null
			this.identity_image_url = ''
		},

		previewImageIdentity(event) {
			if (event) {
				this.identity_image_url = URL.createObjectURL(this.identity_image_upload)
				this.btn_disabled = false
			} else {
				this.identity_image_url = null
				this.btn_disabled = true
			}
		},

		dialogZoomOpen(img) {
			this.imgzoom = img
			this.dialogZoom = true
		},

		changeProvince() {
			this.getCity({ province_id: this.params.province_id	})
			this.params.city_id = ''
			this.params.subdistrict_id = ''
		},

		changeCity() {
			this.getSubdistrict({ city_id: this.params.city_id	})
			this.params.subdistrict_id = ''
		},

		changeProvinceReceiver() {
			this.getCity({ province_id: this.params.receiver_province_id	})
			this.params.receiver_city_id = ''
			this.params.receiver_subdistrict_id = ''
		},

		changeCityReceiver() {
			this.getSubdistrict({ city_id: this.params.receiver_city_id	})
			this.params.receiver_subdistrict_id = ''
		},

		changeBankProvince() {
			this.getBankCity({ province_id: this.params.bank_province_id	})
			this.params.bank_city = ''
		},

		setReceiverAddress() {
			if (this.isEqualAddress) {
				this.params.receiver_address = this.params.address
				this.params.receiver_province_id = this.params.province_id
				this.params.receiver_city_id = this.params.city_id
				this.params.receiver_subdistrict_id = this.params.subdistrict_id
			} else {
				this.params.receiver_address = ''
				this.params.receiver_province_id = ''
				this.params.receiver_city_id = ''
				this.params.receiver_subdistrict_id = ''
			}
		},

		async selectBank() {
			const selectedBank = await this.params.bank_id
			this.params.bank_id = selectedBank.bank_id
			this.params.bank_name = selectedBank.bank_name
		},
		
		getMitraSponsorName(mitra_code, trigger) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response.data).length > 0) {
						if (trigger === 'input') {
							this.sponsor_name = '[' + response.data.member_name + ']'
							this.sponsor_valid = true

							setTimeout(() => {
								this.$refs.upline_network_code.focus()
							}, 200);
						}
					} else {
						this.sponsor_name = ''
						this.sponsor_valid = false
						setTimeout(() => {
							this.$refs.sponsor_network_code.focus()
						}, 200);
					}
					
					this.stepValid.step1 = this.$refs.formStep1.validate()
				}).catch(() => {
					this.sponsor_name = ''
					this.sponsor_valid = false
				})
			} else {
				this.sponsor_name = ''
				this.sponsor_valid = false
			}
		},

		getMitraUplineName(mitra_code, trigger) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response.data).length > 0) {
						this.upline_name = '[' + response.data.member_name + ']'
						this.upline_valid = true

						if (trigger === 'input' && this.$route.query.upline === undefined) {
							setTimeout(() => {
								this.$refs.position.focus()
							}, 200);
						}
					} else {
						this.upline_name = ''
						this.upline_valid = false
						setTimeout(() => {
							this.$refs.upline_network_code.focus()
						}, 200);
					}

					this.stepValid.step1 = this.$refs.formStep1.validate()
				}).catch(() => {
					this.upline_name = ''
					this.upline_valid = false
				})
			} else {
				this.upline_name = ''
				this.upline_valid = false
			}
		},

		getData() {
			this.params.sponsor_network_code = this.userData.member_ref_network_code
			if (this.params.sponsor_network_code) this.getMitraSponsorName(this.userData.member_ref_network_code, 'input')

			this.getProvince()
			this.getCity()
			this.getBankCity()
			this.getBank()
			// this.getTermContent()
		},

		handleFileUpload(event) {
			let formData = new FormData()
			formData.append('image_profile', event)
			this.Preview_image(event)
		},
		
		Preview_image(event) {
      this.stores_image= URL.createObjectURL(event)
    },

		moveUp(offset){
			window.scrollTo(0, offset);
		},

		async seletBank() {
			const selectedBank = await this.params.bank_id
			this.params.bank_id = selectedBank.bank_id
			this.params.bank_name = selectedBank.bank_name
		},

		async step1Process() {
			this.step1loading = await true
			await this.getMitraSponsorName(this.params.sponsor_network_code, 'submit')
			await this.getMitraUplineName(this.params.upline_network_code, 'submit')

			this.stepValid.step1 = await this.$refs.formStep1.validate()

			setTimeout(() => {
				if (this.stepValid.step1) {
					this.stepForm = 2
					this.$refs.email.focus()
				} else {
					this.stepValid.step1 = false
					this.stepForm = 1
					this.moveUp(0)
				}
				this.step1loading = false
			}, 600)
		},

		step2Process() { 
			this.stepValid.step2 = this.$refs.formStep2.validate()
			if (this.$refs.formStep2.validate()) {
				this.stepForm = 3
				this.$refs.bank_account_name.focus()
			} else {
				this.stepValid.step2 = false
				this.stepForm = 2
				this.moveUp(200)
			}
		},

		async backStep(step) {
			this.stepForm = await step
			if(step === 2) {
				this.$refs.name.focus()
			} else if (step === 1) {
				this.$refs.serial_id.focus()
			}
		},

		async saveMitra() {
			this.params.sponsor_network_code = await this.userData.member_ref_network_code
			this.params.identity_image = await this.identity_image_upload

			let formDataRegis = new FormData()
			formDataRegis.append('sponsor_network_code', this.params.sponsor_network_code)
			formDataRegis.append('upline_network_code', this.params.upline_network_code)
			formDataRegis.append('position', this.params.position)
			formDataRegis.append('serial_id', this.params.serial_id)
			formDataRegis.append('serial_pin', this.params.serial_pin)
			formDataRegis.append('username', this.params.username)
			formDataRegis.append('password', this.params.password)
			formDataRegis.append('name', this.params.name)
			formDataRegis.append('email', this.params.email)
			formDataRegis.append('identity_type', this.params.identity_type)
			formDataRegis.append('identity_no', this.params.identity_no)
			formDataRegis.append('mobilephone', this.params.mobilephone)
			formDataRegis.append('gender', this.params.gender)
			formDataRegis.append('birth_place', this.params.birth_place)
			formDataRegis.append('birth_date', this.params.birth_date)
			formDataRegis.append('address', this.params.address)
			formDataRegis.append('subdistrict_id', this.params.subdistrict_id)
			formDataRegis.append('city_id', this.params.city_id)
			formDataRegis.append('province_id', this.params.province_id)
			formDataRegis.append('country_id', this.params.country_id)

			formDataRegis.append('receiver_name', this.params.receiver_name)
			formDataRegis.append('receiver_mobilephone', this.params.receiver_mobilephone)
			formDataRegis.append('receiver_address', this.params.receiver_address)
			formDataRegis.append('receiver_subdistrict_id', this.params.receiver_subdistrict_id)
			formDataRegis.append('receiver_city_id', this.params.receiver_city_id)
			formDataRegis.append('receiver_province_id', this.params.receiver_province_id)

			formDataRegis.append('bank_id', this.params.bank_id)
			formDataRegis.append('bank_name', this.params.bank_name)
			// formDataRegis.append('bank_account_name', this.params.bank_account_name)
			formDataRegis.append('bank_account_name', this.params.name)
			formDataRegis.append('bank_account_no', this.params.bank_account_no)
			formDataRegis.append('bank_city', this.params.bank_city)
			formDataRegis.append('bank_branch', this.params.bank_branch)
			formDataRegis.append('mother_name', this.params.mother_name)
			formDataRegis.append('devisor_name', this.params.devisor_name)
			formDataRegis.append('devisor_relation', this.params.devisor_relation)
			formDataRegis.append('devisor_mobilephone', this.params.devisor_mobilephone)
			formDataRegis.append('identity_image', this.identity_image_upload)

			this.addRegistration(formDataRegis).then((response) => {
				// this.tempRegister = this.params
				this.tempRegister = response.results.data
				// this.tempRegister.sponsor_name = this.sponsor_name
				// this.tempRegister.upline_name = this.upline_name
				// this.successRegistration(this.tempRegister)
				this.isSuccessReg = true
				this.reset()
				setTimeout(() => {
					this.btnLoadingProses = false
					// this.$router.push({name: 'genealogy'})
				}, 600);
			}).catch(() => {
				this.btnLoadingProses = false
			})
		},

		showConfirmAccount(kitas, phone, bank, type) {
			this.typeConfirm = type
			if (type === 'confirm') {
				this.msgConfirm = `
					<p><b>Nomor Identitas</b> / <b>Nomor Handphone</b> / <b>Nomor Rekening Bank</b> ini telah terdaftar pada akun mitra anda di dalam sistem.<br>Gunakan fitur <span class="font-weight-600 text-uppercase">Kloning Akun</span> untuk menambahkan duplikasi akun anda.</p>
				`
			} else {
				this.msgConfirm = `
					<div class="d-block text-left my-3">
						<span class="d-block mb-2"><span style="display: inline-block; width: 135px;">Nomor Identitas</span>: <strong class="text-capitalize">${kitas}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block; width: 135px;">Nomor Handphone</span>: <strong class="text-capitalize">${phone}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block; width: 135px;">Nomor Rekening</span>: <strong class="text-capitalize">${bank}</strong></span>
						<br>
						<p class="mb-1" style="color: darkred;">Data Identitas diatas sudah terdaftar / digunakan oleh mitra DSN. Silakan sesuaikan kembali data akun yang anda daftarkan tersebut.</p>
					</div>
				`
			}
			this.$refs.modalConfirm.modalShow()
		},

		cancelConfirm() {
			if (this.errorValidation.mobilephone !== undefined || this.errorValidation.identity_no !== undefined)	this.stepForm = 2
			else this.stepForm = 3

			setTimeout(() => {
				if (this.errorValidation.mobilephone !== undefined) this.$refs.mobilePhone.$refs.input.select()
				else if (this.errorValidation.identity_no !== undefined) this.$refs.identityNo.$refs.input.select()
				else if (this.errorValidation.bank_account_no !== undefined) this.$refs.accountNo.$refs.input.select()
			})
		},

		processToClone() {
			this.$refs.modalConfirm.loadingButton()
			this.$router.push({name: 'cloning-mitra', query: { sponsor: this.params.sponsor_network_code, upline: this.params.upline_network_code, pos: this.params.position }})
		},

		async processInput() {
			this.stepValid.step3 = await this.$refs.formStep3.validate()
			this.btnLoadingProses = await true
			if (this.$refs.formStep3.validate()) {
				if (!this.stepValid.step1) {
					this.stepForm = 1
					this.isAgreed = false
				} else if (!this.stepValid.step2) {
					this.stepForm = 2
					this.isAgreed = false
				} else {
					const paramCheckAkun = {
						identity_no: this.params.identity_no,
						mobilephone: this.params.mobilephone,
						bank_account_no: this.params.bank_account_no
					}
					
					await this.checkRegistration(paramCheckAkun)
					.then(() => {
						this.saveMitra()
					})
					.catch(() => {
						// console.log('checkRegistration', error)
						if (this.params.identity_no === this.myProfile.member_identity_no || this.params.mobilephone === this.myProfile.member_mobilephone || this.params.bank_account_no === this.myProfile.member_bank_account_no) this.typeConfirm = 'confirm'
						else this.typeConfirm = 'failed'

						this.isAgreed = false
						this.showConfirmAccount(paramCheckAkun.identity_no, paramCheckAkun.mobilephone, paramCheckAkun.bank_account_no, this.typeConfirm)
					})
				}
				
				this.btnLoadingProses = false
			} else {
				this.btnLoadingProses = false
			}
		},

		successRegistration(data) {
			if(data) {
				this.msgSuccess = `
					<span class="font-weight-bold cl-primary font-size-12">Mitra Baru Anda telah berhasil di daftarkan di sistem DSN.</span><br>
					<div class="d-block text-center my-4">`
						data.forEach(akun => {
							this.msgSuccess += `
								<div class="d-block mb-2">
									<span class="d-block"><span style="display: inline-block;">Nama Mitra</span> : <strong>${akun.name}</strong></span>
									<span class="d-block"><span style="display: inline-block;">Kode Mitra</span> : <strong>${akun.code}</strong></span>
									<span class="d-block"><span style="display: inline-block;">Kode Sponsor</span> : <strong>${akun.sponsor_network_code}</strong></span>
									<span class="d-block"><span style="display: inline-block;">Kode Upline</span> : <strong>${akun.upline_network_code}</strong></span>
									<span class="d-block"><span style="display: inline-block;">Posisi Jaringan</span> : <strong>${akun.position}</strong></span>
								</div>`
						})
						
				this.msgSuccess += `</div>
					Informasikan ke mitra baru Anda untuk segera login ke website <a href="${this.voUrlOrigin}">${ this.voUrlHost }</a> dan segera ubah password default tersebut. Salam sukses bersama <strong>DSN!</strong>
				`
				this.resetValidation()
				this.$refs.modalSuccess.modalShow()
			}
		},

		bulkRegister() {
			this.params.sponsor_network_code = this.userData.member_ref_network_code
			this.params.upline_network_code = this.userData.member_ref_network_code
			this.params.position = 'L'
			this.params.serial_id = 'DB10000003',
			this.params.username = 'member23'
			this.params.password = '123456'
			this.params.name = 'Member Dummy'
			this.params.email = 'admin@gmail.com'
			this.params.identity_type = 'KTP'
			// this.params.identity_no = '123123123123123'
			this.params.identity_no = '1234123412344327'
			// this.params.mobilephone = '082247618104'
			this.params.mobilephone = '08123456793'
			this.params.gender = 'Perempuan'
			this.params.birth_place = 'Yogyakarta'
			this.params.birth_date = '2000-12-31'
			this.params.address = 'Jl. Yogyakarta'
			this.params.subdistrict_id = '538'
			this.params.city_id = '39'
			this.params.province_id = '5'
			this.params.country_id = '102'
			this.params.bank_id = '1'
			this.params.bank_name = 'Bank BCA'
			this.params.bank_account_name = 'member bank'
			this.params.bank_account_no = '1234123412344327'
			// this.params.bank_account_no = '12345678910'
			this.params.bank_city = 'Yogyakarta'
			this.params.bank_province_id = '5'
			this.params.bank_branch = 'Katamso'
			this.params.mother_name = 'mother'
			this.params.devisor_name = 'devisor'
			this.params.devisor_relation = 'son'
			this.params.devisor_mobilephone = '08123456789'

			if (this.city && this.params.city_id) {
				this.getSubdistrict({ city_id: this.params.city_id	})
				setTimeout(() => {
					this.params.subdistrict_id = '538'
				}, 600)
			}
		}
	},

	async created() {
		this.loaderData = await true
		await this.resetValidation()
		await this.checkLocation()

		if (this.$route.query.upline !== undefined && this.$route.query.position !== undefined) {
			this.params.upline_network_code = await this.$route.query.upline
			this.params.position = await this.$route.query.position
			this.isUplineExist = await true
			this.getMitraUplineName(this.$route.query.upline)
		}
		await this.$store.dispatch('setPageTitle', 'Registrasi Mitra')
		await this.getData()
		this.getTermContent()

		this.stepForm = await 1
		this.loaderData = false
		// this.bulkRegister()

		setTimeout(() => {
			this.$refs.serial_id.focus()
		}, 200);
	}
};
</script>

<style lang="scss" scoped>
	.icon-upload-image {
		margin-top: -3.3rem !important;
		margin-left: 9.5rem !important;
	}
	
	.btn-zoom {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: rgba(0,0,0,0.4);

		&:hover, &:focus {
			background: rgba(0,0,0,0.6);
		}
	}
</style>
